export const DEFAULT_QUESTION_ANSWER_BLOCK_CLASS_NAME = 'question-answer-block';
